var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-wrapper-docs",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"We Are Soccer","title":"We Are Soccer","logo":"../assets/logo.png"}},[_c('template',{slot:"links"},[(!_vm.isEditor)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-tv-2 text-black',
          path: '/dashboard'
        }}}):_vm._e(),(_vm.isStreamer)?_c('sidebar-item',{attrs:{"link":{
          name: 'Schedule',
          icon: 'ni ni-spaceship text-black',
          path: '/schedule'
        }}}):_vm._e(),(_vm.isAdmin || _vm.isStreamer)?_c('sidebar-item',{attrs:{"link":{
          name: 'Live Stream',
          icon: 'ni ni-planet text-black',
          path: '/live_stream'
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Club',
          icon: 'ni ni-world text-black',
          path: '/club'
        }}}):_vm._e(),(_vm.isEditor || _vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'News Feed',
          icon: 'fa fa-rss text-black',
          path: '/newsfeed'
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Notification',
          icon: 'ni ni-notification-70 text-black',
          path: '/notification'
        }}}):_vm._e(),(_vm.isStreamer || _vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'User Management',
          icon: 'ni ni-single-02 text-black',
          path: '/user_management'
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Configuration',
          icon: 'ni ni-settings text-black',
          path: '/configuration'
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('vue-progress-bar'),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }